import * as React from 'react'
import Svg, { ClipPath, Defs, G, Path, Rect, SvgProps } from 'react-native-svg'

export const SendMessage = (props: SvgProps) => (
  <Svg viewBox='0 0 20 18' fill='none' {...props}>
    <G clipPath='url(#clip0_4440_11210)'>
      <Path
        d='M9.72 16.41L7.32 7.61L1 1.03L18.98 1L9.72 16.41Z'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M18.9803 1L7.32031 7.61'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </G>
    <Defs>
      <ClipPath id='clip0_4440_11210'>
        <Rect width='19.98' height='17.41' fill='white' />
      </ClipPath>
    </Defs>
  </Svg>
)
